import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { Menu, MenuGroup, MenuItem } from '@szhsin/react-menu';
import { isEmpty } from 'lodash';

import { PatientTravelApi } from '../../../../../../../api';
import { STDT_TRAVEL } from '../../../../../../../constants/study/studyTypes';
import { MANAGE_PATIENT_TRAVEL_REQUEST } from '../../../../../../../constants/userOperations';
import { userHasAccessTo } from '../../../../../../../services/auth';
import { NSPP_TRAVEL } from '../../../../../../../services/i18n/namespaces';
import { useCurrentRoute } from '../../../../../../root/router';
import { PatientInfoContext } from '../../PatientInfoContext';

export function AddUnexpectedTravelButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [situationalEncounters, setSituationalEncounters] = useState([]);
  const { currentStudy } = useContext(PatientInfoContext);
  const currentRoute = useCurrentRoute();
  const ssuPatientId = currentRoute.params?.ssuPatientId;
  const studyTypes = currentStudy.types;

  useEffect(() => {
    if (ssuPatientId && isTravelStudy(studyTypes) && userHasAccessTo(MANAGE_PATIENT_TRAVEL_REQUEST)) {
      PatientTravelApi.getSituationalEncounters(ssuPatientId).then(res => {
        setSituationalEncounters(res.data);
      });
    }
  }, [ssuPatientId, studyTypes]);

  if (!isTravelStudy(studyTypes)) {
    return <></>;
  }

  if (isEmpty(situationalEncounters)) {
    return (
      <Button variant="outlined" size="small" disabled={true}>
        {t(`${NSPP_TRAVEL}:travelRequests.addUnexpectedTravel`)}
      </Button>
    );
  }

  if (situationalEncounters.length === 1) {
    return (
      <Button
        variant="outlined"
        size="small"
        onClick={() => {
          navigate(`./travel-request?protocolSituationalEncounterId=${situationalEncounters[0].id}`);
        }}
      >
        {t(`${NSPP_TRAVEL}:travelRequests.addUnexpectedTravel`)}
      </Button>
    );
  } else {
    return (
      <Menu
        align="start"
        direction="left"
        portal={true}
        menuButton={
          <Button variant="outlined" size="small">
            {t(`${NSPP_TRAVEL}:travelRequests.addUnexpectedTravel`)}
          </Button>
        }
      >
        <MenuGroup>
          {situationalEncounters.map(enc => (
            <MenuItem
              key={enc.id}
              onClick={() => {
                navigate(`./travel-request?protocolSituationalEncounterId=${enc.id}`);
              }}
              title={enc.name.length > 50 ? enc.name : null}
              className="bold-text"
            >
              {enc.name}
            </MenuItem>
          ))}
        </MenuGroup>
      </Menu>
    );
  }
}

function isTravelStudy(types) {
  return types?.includes(STDT_TRAVEL);
}
